import axios from 'axios'
import { getStorage } from '@/utils/common'
import { Toast } from 'vant'

const request = axios.create({
  timeout: 60000,
})
// 允许出现多个Toast
// Toast.allowMultiple();
// 请求拦截器
request.interceptors.request.use(
  config => {
    Toast.loading({
      duration: 0,
      forbidClick: true,
    })
    const token = getStorage('wechatToken')
    config.headers.post['Content-Type'] = 'application/json'
    config.headers['Authorization'] = '123'
    // config.headers['Authorization'] = token;
    return config
  },
  error => {
    return Promise.reject(error)
  },
)

// 请求返回拦截器
request.interceptors.response.use(
  response => {
    const res = response.data
    const { code, message } = res
    if (code === 'SUCCESS' || message === 'OK') {
      Toast.clear()
      return Promise.resolve(res)
    }

    Toast.fail({
      forbidClick: true,
      message: res.msg,
    })
    Toast.clear()
    return Promise.reject(res)
  },
  error => {
    Toast.clear()
    Toast.fail({
      forbidClick: true,
      message: res.msg,
    })
    return error
  },
)

export default request
